import { Theme } from '@mui/material'

const useStyles = {
  container: () => ({
    paddingTop: 0.5,
    flexDirection: 'column',
  }),
  desktopHeader: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    paddingTop: 2,
    paddingBottom: 1,
    fontWeight: 500,
    color: theme.palette.text.secondary,
  }),
  contentContainer: {
    flexDirection: 'column',
    paddingY: 2,
    gap: '40px',
  },
  linkContainer: { gap: 2, paddingBottom: 3, flexDirection: 'column' },
  helpLinkGrid: (theme: Theme) => ({
    paddingY: 1.5,
    paddingX: 2,
    alignItems: 'center',
    gap: 2,
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1.5),
  }),
  helpText: { fontWeight: 500, flex: 1 },
  supportButtonContainer: { justifyContent: 'center', alignItems: 'center' },
  hiddenChatButtonContainer: { height: 0, opacity: 0, width: 0 },
  chatAvailabilityText: { marginTop: 1 },
  requestHelpButton: { borderRadius: '16px' },
}

export default useStyles
